/**
 * M2 ECS component stores (bitECS 0.4 SoA, indexed by entity id like src/world/components.ts, which M2 does not
 * touch). Written and read as plain typed arrays; zeroed state means "no tool, no group".
 */
import { MAX_ENTITIES } from '../world/components'

export { MAX_ENTITIES }

/**
 * Tool intent for any ship (D-TBD: tools are ship systems driven by `ToolControl`). The tools runtime writes the
 * player's each tick; M4/M6 AI miners write their own. `mode` is a `TOOL` value, `fire` = primary trigger
 * (beam on), `alt` = secondary trigger (tractor in Salvage mode), `power` = smoothed laser power 0..1.
 */
export const ToolControl = {
  mode: new Uint8Array(MAX_ENTITIES),
  fire: new Uint8Array(MAX_ENTITIES),
  alt: new Uint8Array(MAX_ENTITIES),
  power: new Float32Array(MAX_ENTITIES),
}

/** Encounter group of a spawned AI ship (0 = none; group ids start at 1). */
export const EncounterTag = { group: new Int32Array(MAX_ENTITIES) }

/** Clears both stores for `eid` (call when an entity id is reused by a spawn that is not an M2 group ship). */
export function resetSpaceComponents(eid: number): void {
  ToolControl.mode[eid] = 0
  ToolControl.fire[eid] = 0
  ToolControl.alt[eid] = 0
  ToolControl.power[eid] = 0
  EncounterTag.group[eid] = 0
}
